import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { resetPassword } from '@aws-amplify/auth';
import { Form, Button, Alert } from 'react-bootstrap';
import './LoginPage.css';
import { normalizeLoginUsername } from '../utils/normalizeSignupPhone';

export function ForgotPasswordPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      const username = normalizeLoginUsername(email);
      await resetPassword({ username });
      navigate(`/reset-password?email=${encodeURIComponent(username)}`);
    } catch (err) {
      setError(err.message || 'Failed to send reset code. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="tg-auth-card">
        <div className="tg-auth-brand">
          <div className="tg-auth-brand-mark">T</div>
          <span className="tg-auth-brand-name">Tegrat Auto</span>
        </div>

        <h2 className="tg-auth-title">Reset your password</h2>
        <p className="tg-auth-subtitle">
          Enter the email or phone number you used to sign up. We'll send a code to your verified contact address.
        </p>

        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3" controlId="email">
            <Form.Label>Email or signup phone number</Form.Label>
            <Form.Control
              type="text"
              name="username"
              autoComplete="username"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@example.com or (555) 000-0000"
              disabled={loading}
              required
              autoFocus
            />
          </Form.Group>

          {error && <Alert variant="danger">{error}</Alert>}

          <div className="d-grid gap-2">
            <Button variant="primary" type="submit" disabled={loading} size="lg">
              {loading ? 'Sending…' : 'Send Reset Code'}
            </Button>
          </div>
        </Form>

        <hr className="tg-auth-divider" />
        <div className="tg-auth-footer">
          <Link to="/">Back to sign in</Link>
        </div>
      </div>
    </div>
  );
}

export default ForgotPasswordPage;
